export default __webpack_public_path__ + "static/media/unique.590a9ecc.svg";